<header matDialogTitle>
  <h1>{{ data.title }}</h1>
</header>

<mat-dialog-content>
  <mtna-search-box [debounce]="400" (search)="search($event); _scrollToTop()"></mtna-search-box>

  <mat-list cdkScrollable [ngStyle]="data.listStyles" role="listbox">
    <mat-radio-group [(ngModel)]="selectedVariable">
      <mat-list-item *ngFor="let variable of displayedVariables; trackBy: trackByCr" role="option">
        <mat-radio-button labelPosition="before" [value]="variable">
          <h4 mat-line class="mat-subheading-2">{{ variable.name }}</h4>
          <p *ngIf="!!variable.label" class="mat-body-1" mat-line>{{ variable.label }}</p>
        </mat-radio-button>
      </mat-list-item>
      <mat-list-item *ngIf="!filteredVariables.length">
        <p mat-line>No items found</p>
      </mat-list-item>
    </mat-radio-group>
  </mat-list>
  <mat-paginator
    [length]="filteredVariables.length"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 25, 50]"
    (page)="paginate($event); _scrollToTop()"
  ></mat-paginator>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" [matDialogClose]="null" i18n>CANCEL</button>

  <button mat-raised-button color="primary" [disabled]="!selectedVariable" [matDialogClose]="selectedVariable" i18n>SELECT</button>
</mat-dialog-actions>
